module.exports = __webpack_public_path__ + "static/media/kyc.e82c489c.svg";